import React from 'react';
import Slider from '@wix/da-ds/pkg/Slider';
import Attachment from '../../../DeviationViews/Attachment';
import s from './AdditionalImages.scss';
const THUMB_SIZE = 92;
const AdditionalImages = ({ attachments })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Slider, null, attachments.map((attachment, idx)=>/*#__PURE__*/ React.createElement(Attachment, {
            key: `attachment-${idx}`,
            className: s['attachment'],
            attachment: attachment,
            width: THUMB_SIZE,
            height: THUMB_SIZE
        }))));
};
AdditionalImages.displayName = 'AdditionalImages';
export default AdditionalImages;

//# sourceMappingURL=AdditionalImages.js.map